import { createRouter, createWebHistory } from "vue-router";
import navigationGuard from "@/utils/Authentication/implicitOnNavigationGuard";
import { auth } from "@/utils/LtkAuth0";
import i18n from "@/locales/i18n";
import rs_wechat from "@/config/rs_wechat";
import { getCurrentEnv, SUPPORT_ENV } from "@/utils/util";

const { t } = i18n.global;
let envConf: any  = 'dev';
const env: any = getCurrentEnv();

if (env === SUPPORT_ENV.prod) {
  envConf = rs_wechat.prod;
} else if (env === SUPPORT_ENV.qa) {
  envConf = rs_wechat.qa;
} else {
  envConf = rs_wechat.dev;
}

const routes: any = [
  {
    path: "/",
    component: () => import("../App.vue")
  },
  {
    path: "/login",
    name: "Login",
    beforeEnter: async () => {
      return auth.login();
    },
    meta: { requiresAuth: false }
  },
  {
    name: "loginCallback",
    path: "/login/callback",
    beforeEnter: async () => {
      await auth.handleRedirectCallback();
    },
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/reward-data",
    name: "RewardData",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "reward_data" */ "@/views/RewardData/RewardData.vue"
      ),
  },
  {
    path: "/reward-details",
    name: "RewardDetails",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "reward_details" */ "@/views/RewardData/RewardDetails.vue"
      ),
  },
  {
    path: "/data-details",
    name: "DataDetails",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "data_details" */ "@/views/RewardData/DataDetails.vue"
      ),
  },
  {
    path: "/error",
    name: "Error",
    component: () =>
      import(/* webpackChunkName: "error" */ "@/views/LtkError.vue"),
  },
  {
    path: "/logged-in",
    name: "LoggedIn",
    meta: { requiresAuth: true },
    component: () =>
      import(/* webpackChunkName: "loggedIn" */ "@/views/LoggedIn.vue"),
  },
  {
    path: "/advertiser-list",
    name: "AdvertiserList",
    meta: { requiresAuth: true },
    component: () =>
      import(
        /* webpackChunkName: "rewardData" */ "@/views/AdvertiserList.vue"
      ),
  },
  {
    path: "/blog-list",
    name: "BlogList",
    meta: { requiresAuth: false },
    component: () => import("@/views/BlogList.vue"),
  },
  {
    path: "/basic-use",
    name: "BasicUse",
    meta: { requiresAuth: false },
    component: () =>
      import(/* webpackChunkName: "basicUse" */ "@/views/BasicUse.vue"),
  },
  {
    path: "/apply",
    component: () => import("@/views/CreatorApplication/ApplicationView.vue"),
    meta: {
      title: "Application",
      requiresAuth: false,
    },
    children: [
      {
        name: "ApplicationForm",
        path: "form",
        meta: {
          title: t("application-form.formName"),
          requiresAuth: false,
        },
        component: () =>
          import("@/views/CreatorApplication/ApplicationForm.vue"),
      },
      {
        name: "ApplicationSubmitResult",
        path: "result",
        meta: {
          title: t("application-form.formName"),
          requiresAuth: false,
        },
        component: () => import("@/views/CreatorApplication/SubmitResult.vue"),
      },
    ],
  },
  {
    path: "/kick-off",
    component: () => import("@/views/KickOff/KickOffView.vue"),
    meta: {
      title: "LTK品牌入驻",
      requiresAuth: false,
    },
    children: [
      {
        name: "KickOffForm",
        path: "form",
        meta: {
          title: "LTK品牌入驻",
          requiresAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "kick-off-form" */ "@/views/KickOff/KickOffForm.vue"
          ),
      },
      {
        name: "SubmitResult",
        path: "result",
        meta: {
          title: "LTK品牌入驻",
          requiresAuth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "kick-off-form" */ "@/views/KickOff/SubmitResult.vue"
          ),
      },
      {
        path: "/welcome-article",
        name: "WelcomeArticle",
        meta: { requiresAuth: false },
        component: () => null,
        beforeEnter: () => {
          window.location.href = envConf.welcomeArticle;
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log(`To: ${to} From: ${from}`);
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach(navigationGuard);

export default router;